import { render, staticRenderFns } from "./newrelic.vue?vue&type=template&id=3e4e4682&"
import script from "./newrelic.vue?vue&type=script&lang=js&"
export * from "./newrelic.vue?vue&type=script&lang=js&"
import style0 from "./newrelic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports